import $http from '$http'
import {
  lg,
  util
} from 'utils';
import {
  GetERP_OrderById
} from '@api/orderApi.js';

export default {
  methods: {
    //初始化加载页面
    List() {
      this.lists = [];
      this.loading2 = true; //拼命加载中显示
      let para = this.getParams();
      let str = this.$route.path
      let index = str.lastIndexOf(":")
      let MenuId = str.substring(index + 1, str.length)
      if (index < 0) {
        return;
      }
      para.MenuId = MenuId
      $http.get('api/Order/GetOrderCommonByPage', para).then(res => {
        this.loading2 = false; //拼命加载中隐藏
        util.doResult(this, res, () => {
          let {
            StateCode,
            StateMsg,
            Data,
            Cnt
          } = res.data;
          this.lists = Data;
          this.totalSize = Cnt;

        });
      });
    },
    // 获取套餐列表
    GetParmConfig() {
      let para = {
        Sid: this.Session[0],
        Session: this.Session[1],
        ParmType: 101
      };
      $http.get('api/Common/GetParmConfig', para).then(res => {
        util.doResult(this, res, () => {
          let {
            Data,
            Cnt
          } = res.data;
          this.packageList = Data
        });
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/Order/orderViewList/OrderQ2Page/services.js